import { useServicesQuery } from '@/services/api';
import type { ServicesApiGetEnvHealthQueryParams } from '@/services/api/services-api';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE } from '../constants';

export function useEnvHealthSegments(workspaceId: number, simulate: ServicesApiGetEnvHealthQueryParams['simulate']) {
  return useServicesQuery(
    'getEnvHealthSegments',
    { params: { environment_id: workspaceId }, query: { simulate } },
    {
      refetchInterval: WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE,
      enabled: workspaceId > 0,
      refetchOnWindowFocus: 'always',
    },
  );
}
